export default (userAttributes) => {
  const issuerName = userAttributes.iss.split('/').pop();
  const groups = userAttributes['cognito:groups'] ?? [];
  return {
    consoleRoles: groups.filter((g) => !g.startsWith(issuerName)),
    isTenantUser: !!groups.filter((g) => g.startsWith(issuerName)).length,
  };
};
